import { exports as arrayLikeToArrayExports, __module as arrayLikeToArray } from '../../../../_virtual/arrayLikeToArray.js';

var hasRequiredArrayLikeToArray;

function requireArrayLikeToArray () {
	if (hasRequiredArrayLikeToArray) return arrayLikeToArrayExports;
	hasRequiredArrayLikeToArray = 1;
	(function (module) {
		function _arrayLikeToArray(arr, len) {
		  if (len == null || len > arr.length) len = arr.length;
		  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
		  return arr2;
		}
		module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
} (arrayLikeToArray));
	return arrayLikeToArrayExports;
}

export { requireArrayLikeToArray as __require };
//# sourceMappingURL=arrayLikeToArray.js.map
